import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnDestroy,
  OnInit,
  signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { MainBanner } from '@core/models/piramide/mainBanner';
import { BannerHandlerService } from '@core/services/BannerHandler.service';
import { PiramidalService } from '@core/services/piramidal.service';
import { Subject, takeUntil } from 'rxjs';
import { CarouselBaseComponent } from 'src/app/home-page/components/carousel-base/carousel-base.component';
import { CarouselItemBase } from 'src/app/home-page/components/carousel-base/carousel-item-base.model';
import { PresentationVideoComponent } from 'src/app/home-page/components/presentation-video/presentation-video.component';
import { SwiperOptions } from 'swiper/types';
import { CAROUSEL_BASE_DEFAULT_CONFIG } from 'src/app/home-page/components/carousel-base/carousel-base.default-config';

@Component({
  selector: 'cgw-main-banner-section',
  standalone: true,
  imports: [
    // Components
    CarouselBaseComponent,
    PresentationVideoComponent,
  ],
  templateUrl: './main-banner-section.component.html',
  styleUrl: './main-banner-section.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainBannerSectionComponent implements OnInit, OnDestroy {
  private readonly _bannerTemplateRef = viewChild('bannerTemplate', { read: TemplateRef });
  private readonly _destroyS = new Subject<boolean>();

  public readonly carouselConfig = signal<SwiperOptions>({
    ...CAROUSEL_BASE_DEFAULT_CONFIG,
    loop: true,
    on: {
      realIndexChange: (swp) => {
        this.carouselCurrSlide.set(swp.realIndex);
      },
    },
  });
  public readonly carouselItems = signal<CarouselItemBase<MainBanner>[]>([]);
  public readonly carouselCurrSlide = signal<number>(0);

  constructor(
    private piramidal: PiramidalService,
    private bannerHandler: BannerHandlerService,
  ) {}

  public ngOnInit(): void {
    this.piramidal.mainBanners.observable.pipe(takeUntil(this._destroyS)).subscribe((res) => {
      const banners = res.filter(
        (banner) =>
          banner.estado &&
          this.bannerHandler.verificarFechayHorario(banner) &&
          this.bannerHandler.verificarNewImages(banner),
      );

      const orderedBanners = banners
        .filter((banner) => banner.orden !== 0)
        .sort((a, b) => a.orden - b.orden);

      const randomBanners = banners
        .filter((banner) => banner.orden === 0)
        .sort(() => Math.random() - 0.5);

      const imagesTotal: Array<MainBanner> = [...orderedBanners, ...randomBanners].map((image) => {
        image.link = this.normalizeLink(image.link);
        return image;
      });
      const finalBanners = imagesTotal.map(
        (b) =>
          new CarouselItemBase({
            id: b.id,
            data: b,
            templateRef: this._bannerTemplateRef(),
            templateContext: { image: b },
          }),
      );

      this.carouselItems.set(finalBanners);
    });
  }

  public ngOnDestroy(): void {
    this._destroyS.next(true);
    this._destroyS.complete();
  }

  private normalizeLink(link: string): string {
    const hasProtocol = link.startsWith('https://');
    const hasParams = link.includes('?');
    const needsTrailingSlash = !link.endsWith('/') && !hasParams;

    return `${hasProtocol ? '' : 'https://'}${link}${needsTrailingSlash ? '/' : ''}`;
  }
}
